import { View }     from 'backbone';
import listService  from 'ListService.js'
import Template     from 'behaviors/properties/main/select-page.ejs';
import widgetUtil   from 'util/WidgetUtil.js';
//=====================================================================
//
// An instance of this view represents a page selection.
//
// M Rocha, Jun 8, 2016
//
//=====================================================================

class MainSelectPage extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change select'                 : 'updateSelectAttributes',
            'change input[type=radio]'      : 'updateAttributes'
        };

        this.getPagesList();

        if (this.model.get('specificDisabled') === undefined) {
            this.model.set('specificDisabled', 'disabled', {silent:true});
        }

        if (!this.model.get('pageType')) {
            this.model.set('pageType', 'next', {silent:true});
        } else if (this.model.get('pageType')=== 'specific') {
            this.model.set('specificDisabled', '',{silent:true});
        }

        if (!this.model.get('specific')) {
            this.model.set('specific', this.model.get('pagesList')[0], {silent:true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        let text = ev.currentTarget.options[ev.currentTarget.selectedIndex].innerText;

        this.model.set( propName, listService.getCleanedId(propVal),{silent:true} );
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true});
        this.model.trigger('change');
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal, {silent:true} );

        if (this.model.get('pageType') === 'specific'){
            this.model.set('specificDisabled', '', {silent:true});
            const pageId = $('#pages option:selected').val();
            const pageName = $('#pages option:selected').text();

            this.model.set( 'page', listService.getCleanedId(pageId),{silent:true} );
        } else {
            this.model.set('specificDisabled', 'disabled', {silent:true});
        }
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true});
        this.model.trigger('change');
    }

    updateForm() {
        $("input:radio[value='"+this.model.get('pageType')+"']").attr('checked', true);

        $("#pages option[value='"+ listService.cleanId(this.model.get('page')) +"']").attr( "selected", true );
    }


    addPages(){
        let pagesList = [];
        $('#pages').empty();

        listService.pageList.map( v => {
            pagesList.push(v.model.get( 'pageTitle' ));
            $('#pages').append('<option value="' + v.model.get('id') + '">' + v.model.get('name') + '</option>')
        });
    }

    getPagesList(){
        let pagesList = [];
        listService.pageList.map( v => {
            pagesList.push(v.model.get( 'pageTitle' ));
        });
        this.model.set('pagesList', pagesList, {silent: true});
    }

    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.addPages();
        this.updateForm();
        this.delegateEvents();
        return this;
    }

}

export default MainSelectPage;
